var countriesJSON = require("json!../static/countries.json");

const $inject = [];
const countriesService = function () {
  let service = {};

  service.get = function get() {
    return countriesJSON;
  };

  return service;
};

countriesService.$inject = $inject;

export default countriesService;


// WEBPACK FOOTER //
// ./src/services/countriesService.js